import { useState } from 'react'
import PricingPackageCard from './PricingPackageCard'
import StripeCheckoutModal from '../modals/StripeCheckoutModal'

// Centralized package data - single source of truth
export const CREDIT_PACKAGES = [
  { id: 'pkg-starter-10', name: 'STARTER', price: 10, credits: 10, bonus: 0, bonusText: 'No bonus' },
  { id: 'pkg-power-50', name: 'POWER', price: 50, credits: 52.5, bonus: 2.5, bonusText: '+5% BONUS', popular: true },
  { id: 'pkg-pro-100', name: 'PRO', price: 100, credits: 115, bonus: 15, bonusText: '+15% BONUS', bestValue: true },
  { id: 'pkg-enterprise-500', name: 'ENTERPRISE', price: 500, credits: 600, bonus: 100, bonusText: '+20% BONUS' },
]

export default function PricingPackages({ compact = false, showHeader = true, maxPackages = null }) {
  const [selectedPackage, setSelectedPackage] = useState(null)
  const [showCheckoutModal, setShowCheckoutModal] = useState(false)

  const handlePurchase = (pkg) => {
    setSelectedPackage(pkg)
    setShowCheckoutModal(true)
  }

  const handleCloseCheckout = () => {
    setShowCheckoutModal(false)
    setSelectedPackage(null)
  }

  const packagesToShow = maxPackages ? CREDIT_PACKAGES.slice(0, maxPackages) : CREDIT_PACKAGES

  return (
    <>
      {showHeader && (
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Buy Credits & Save More</h2>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Purchase credits to power your processing - larger packages include bonus credits!
          </p>
        </div>
      )}

      {/* Pricing Cards Grid */}
      <div className={`grid ${compact ? 'grid-cols-2 md:grid-cols-4 gap-4' : 'md:grid-cols-2 lg:grid-cols-4 gap-6'} ${compact ? '' : 'mb-8'}`}>
        {packagesToShow.map(pkg => (
          <PricingPackageCard
            key={pkg.id}
            pkg={pkg}
            onPurchase={handlePurchase}
            compact={compact}
          />
        ))}
      </div>

      {/* Stripe Checkout Modal */}
      {showCheckoutModal && selectedPackage && (
        <StripeCheckoutModal
          onClose={handleCloseCheckout}
          package={selectedPackage}
        />
      )}
    </>
  )
}
